import Swal from "sweetalert2";
import { config } from "./CommonURLS";

const showPDF = (imgg) => ConvertFileToBase64(imgg)
    .then(base64Data => {
        const extractedData = base64Data.split(',')[1];
        const binaryData = atob(extractedData);
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
            uint8Array[i] = binaryData.charCodeAt(i);
        }
        const blob = new Blob([uint8Array], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
    })
    .catch(error => {
        console.error('Error:', error);
    });
async function ConvertFileToBase64(fileUrl) {
    let img = fileUrl?.includes("affiliation") ? fileUrl : "affiliation/" + fileUrl;
    const response = await fetch(img);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    })
}

export function viewImage(fileName) {
    console.log("fileName:")
    let img = fileName?.includes("affiliation") ? fileName : "affiliation/" + fileName;
    let url = config.url.FILE_DOWNLOAD_URL + img;
    // const dataType = fileName?.split(".")[1];
    const dataType = fileName?.split(".").pop()?.toLowerCase();
    if (dataType === "pdf" || dataType === "PDF") {
        showPDF(url);

    } else if (dataType === "text") {
        const newTab = window.open();
        newTab.document.body.innerHTML =
            `<embed src="${url}" width="100%" height="100%" ></embed>`;
    } else if (dataType === "mp4" || dataType === "avi" || dataType === "mov" || dataType === "mkv") {
        // Create a video element to view the video in a modal
        Swal.fire({
            html: `<video controls width="100%">
                     <source src="${url}" type="video/${dataType}">
                     Your browser does not support the video tag.
                   </video>`,
            width: '80%',
            showCloseButton: true,
            showConfirmButton: true,
            confirmButtonText: 'Download Video',
            customClass: {
                content: 'custom-modal-content',
            },
        }).then((result) => {
            if (result.isConfirmed) {
                // Trigger the download of the video
                const a = document.createElement('a');
                a.href = url;
                a.download = img;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
        });
    } else {

        const swalPopup = Swal.fire({
            html: `<img src="${url}" class="img-thumbnail" />`,
            width: '80%',
            showCloseButton: true,
            showConfirmButton: false,
            customClass: {
                content: 'custom-modal-content',
            },
        });
        window.addEventListener('popstate', () => {
            swalPopup.close();
        });
    }
}










